// eslint-disable-next-line import/named,import/no-named-as-default
import Hls, { HlsConfig } from 'hls.js'

export function CreateHls(
  src: string,
  media: HTMLVideoElement,
  config = {} as Partial<HlsConfig>
) {
  const hls = new Hls(config)
  hls.loadSource(src)
  hls.attachMedia(media)
  return hls
}

export function IsNativeHls(vue: Vue, media?: HTMLVideoElement): boolean {
  if (!vue.$isClient) return false
  // We don't currently care if we _can_ do Hls, we'd rather do native
  // if (Hls.isSupported()) return false
  if (!media) return false
  return !!media.canPlayType('application/vnd.apple.mpegurl')
}
